<template>
  <v-card v-bind="$attrs" class="lockable-card">
    <!-- Card content -->
    <slot />
    <!-- Overlay displayed on top -->
    <div v-if="locked" class="locked-overlay">
      <div class="locked-message">
        <!-- Not sure if this message should be a slot -->
        Please wait until upload is completed
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'LockableCard',
  props: {
    locked: Boolean,
  },
};
</script>

<style scoped>
.lockable-card {
  position: relative;
}

.locked-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-radius: inherit;
}

.locked-message {
  color: white;
}
</style>
